import { render, staticRenderFns } from "./SingleLayerStyle.vue?vue&type=template&id=edf7ce8c&scoped=true"
import script from "./SingleLayerStyle.vue?vue&type=script&lang=ts"
export * from "./SingleLayerStyle.vue?vue&type=script&lang=ts"
import style0 from "./SingleLayerStyle.vue?vue&type=style&index=0&id=edf7ce8c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edf7ce8c",
  null
  
)

export default component.exports